const GET_PROMO_BY_ID_LOADING = 'promo/GET_PROMO_BY_ID_LOADING'
const GET_PROMO_BY_ID_SUCCESS = 'promo/GET_PROMO_BY_ID_SUCCESS'
const GET_PROMO_BY_ID_ERROR = 'promo/GET_PROMO_BY_ID_ERROR'
const GET_PROMO_LIST_LOADING = 'GET_PROMO_LIST_LOADING';
const GET_PROMO_LIST_SUCCESS = 'GET_PROMO_LIST_SUCCESS';
const GET_PROMO_LIST_FAILED = 'GET_PROMO_LIST_FAILED';

export {
  GET_PROMO_BY_ID_LOADING,
  GET_PROMO_BY_ID_SUCCESS,
  GET_PROMO_BY_ID_ERROR,
  GET_PROMO_LIST_LOADING,
  GET_PROMO_LIST_SUCCESS,
  GET_PROMO_LIST_FAILED
}
